var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTDebit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3335 9.16682C6.3335 9.81349 6.83351 10.3335 7.44684 10.3335H8.70015C9.23349 10.3335 9.66683 9.88015 9.66683 9.31349C9.66683 8.70682 9.40017 8.48682 9.00684 8.34682L7.00016 7.64682C6.60683 7.50682 6.34017 7.29349 6.34017 6.68016C6.34017 6.12016 6.77349 5.66016 7.30682 5.66016H8.56016C9.17349 5.66016 9.6735 6.18016 9.6735 6.82682",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 5V11",
    stroke: "#121212",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6668 8.00065C14.6668 11.6807 11.6802 14.6673 8.00016 14.6673C4.32016 14.6673 1.3335 11.6807 1.3335 8.00065C1.3335 4.32065 4.32016 1.33398 8.00016 1.33398",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 4.00065V1.33398H12",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 4.66732L14.6668 1.33398",
    stroke: "#121212",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTDebit);
export default __webpack_public_path__ + "static/media/t_debit.1ca0434d6607ca488b1073f4f907d9bf.svg";
export { ForwardRef as ReactComponent };